import Directors from "./directors";
import Signatories from "./signatories";
import config from '../../config/form.json';
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { hasInwardBank, inwardPartner,newPartnerList, productSelection } from "../../store/gloabalState";
import { Button } from "antd";
import { getDirectors, updateOrg, getAllAuths } from "../../services/httpCalls";
import { editactive, showloader, checkFilledDirector } from "../../store/gloabalState";
import useNotify from "../../utils/useNotify"
import { showField, NEW_REFACTOR} from "../../utils/onboarding/onboardingUtils";
import Cookies from "js-cookie";
import { getProductionSelectionType } from "../../utils/onboarding/onboardingUtils";

const DirectorDetails = ({ handleChange, orgDetails }) => {

    const configData = config.directorDetails[2].data[0];

    // global states

    // updater/setter
    const setShowLoader = useSetRecoilState(showloader)

    // values
    const isEditActive = useRecoilValue(editactive)
    const partnerState = useRecoilValue(inwardPartner)
    const directorsDataFilled = useRecoilValue(checkFilledDirector)
    const hasInwardBankValue = useRecoilValue(hasInwardBank);
    const partnerListState = useRecoilValue(newPartnerList);


    // states
    let [selectionValue, setSelectionValue] = useRecoilState(productSelection);


    // constants/binders
    let notify = useNotify()
    const {hasOnlyPayglocal} = getProductionSelectionType(selectionValue,partnerState, hasInwardBankValue);
    const directorsShouldRender = !hasInwardBankValue && partnerState.length > 0 && ["SOLE_PRORIETOR", "FREELANCER"].includes(orgDetails?.companyType)

    const next = async () => {
        let orgId = localStorage.getItem("orgId")
        if(!directorsShouldRender) {
          await getDirectors(orgId)
          .then(async (res) => {
            if (res.length) {
              if (res.length < 2 && 
                  selectionValue !== "outward" &&
                  orgDetails?.companyType !== "SOLE_PRORIETOR" &&
                  orgDetails?.companyType !== "OPC" &&
                  orgDetails?.companyType !== "FREELANCER"
                ) {
                notify.error("Minimum 2 Directors is required!")
                return false
              }
              if (selectionValue === "inward" && !partnerState.includes("payglocal")) {
                let data = {
                  status: "DRAFT_SHAREHOLDERS"
                }
                if (!isEditActive) {
                  setShowLoader(true)
                  if (directorsDataFilled) {
                    await updateOrg(data, orgId)
                      .then((res) => {
                        if (directorsDataFilled)
                          handleChange(5);
                        Cookies.set("currentStage", "5")
    
                      }).finally(() => setShowLoader(false))
                  } else {
                    notify.error("Please fill directors information ")
                  }
                } else {
                  handleChange(5);
                  Cookies.set("currentStage", "5")
                }
              } else {
                if (directorsDataFilled) {
                  await getAllAuths(orgId)
                    .then(async (res) => {
                      if (res.length) {
                        let data = {
                          status: "DRAFT_SHAREHOLDERS"
                        }
                        let checkAuthFill = res?.length ? res?.filter((val) => val?.status !== "DELETED") : 0
                        if (!isEditActive) {
                          setShowLoader(true)
                          if (checkAuthFill.length) {
                            await updateOrg(data, orgId)
                              .then((res) => {
                                if (checkAuthFill.length > 0) {
                                  handleChange(5);
                                  Cookies.set("currentStage", "5")
                                }
                              }).finally(() => setShowLoader(false))
                          }
                          else {
                            notify.error("Add atleast one authorised signatory!")
                          }
                        } else {
                          handleChange(5);
                          Cookies.set("currentStage", "5")
                        }
                      } else {
                        notify.error("Please enter the details for Authorised Signatory")
                      }
                    }).finally(() => setShowLoader(false))
                }
    
                else {
                  notify.error("Please enter the details for Directors!")
                }
              }
    
            } else {
              notify.error("Add at least one  Directors!")
            }
          }).finally(() => setShowLoader(false))
        } else {
          await getAllAuths(orgId)
                    .then(async (res) => {
                      if (res.length) {
                        let data = {
                          status: "DRAFT_SHAREHOLDERS"
                        }
                        let checkAuthFill = res?.length ? res?.filter((val) => val?.status !== "DELETED") : 0
                        if (!isEditActive) {
                          setShowLoader(true)
                          if (checkAuthFill.length) {
                            await updateOrg(data, orgId)
                              .then((res) => {
                                if (checkAuthFill.length > 0) {
                                  handleChange(5);
                                  Cookies.set("currentStage", "5")
                                }
                              }).finally(() => setShowLoader(false))
                          }
                          else {
                            notify.error("Add atleast one authorised signatory!")
                          }
                        } else {
                          handleChange(5);
                          Cookies.set("currentStage", "5")
                        }
                      } else {
                        notify.error("Please enter the details for Authorised Signatory")
                      }
                    }).finally(() => setShowLoader(false))
        }
      }

    const renderField = (field, index) => {
        const { type, label, name, props, style, tooltip } = field

         // * formatting rules
         field?.rules?.forEach(item => {
            if (item?.pattern) {
              item.pattern = eval(item?.pattern);
            } 
            if (item?.required) {
                item.required = eval(item?.required)
            }
            if (item?.validator) {
                item.validator = eval(item?.validator)
            }
        });
        switch (type) {
            case 'Directors':
                return <Directors/>    
            ;
            case 'Signatories':
                return <Signatories/>    
            ;
            default:
                return null;
        }

    }

    return(
        <div>
            {
                configData.fields.map((field, index) => {

                    const isVisible = showField(field.productList , partnerListState);

                    const isRefactoredRender = isVisible;                    

                    return isRefactoredRender && (
                        renderField(field, index)
                    )
                })
            }
            <div className='fixed_btn_wrap'>
                <Button onClick={() => handleChange(3)}>Previous</Button>
                <Button type="primary" style={{ marginLeft: ".5rem" }} onClick={next}>Next</Button>
            </div>
        </div>
    )

}

export default DirectorDetails;